import { render, staticRenderFns } from "./TeflNewsletter.vue?vue&type=template&id=c7bb8152&"
import script from "./TeflNewsletter.vue?vue&type=script&lang=js&"
export * from "./TeflNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UILoading: require('/opt/build/repo/components/UI/Loading.vue').default})
